import { render, staticRenderFns } from "./remPutaway.vue?vue&type=template&id=6a6c2d04&scoped=true&"
import script from "./remPutaway.vue?vue&type=script&lang=js&"
export * from "./remPutaway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c2d04",
  null
  
)

export default component.exports